import { CheckCircle, MessageSquare } from "lucide-react";

export const AIAssistant: React.FC<{ message: string; showActions?: boolean }> = ({
  message,
  showActions = true,
}) => {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6 max-w-md">
      <div className="flex items-start gap-3 mb-4">
        <div className="w-10 h-10 bg-indigo-600 rounded-full flex items-center justify-center flex-shrink-0">
          <MessageSquare className="w-5 h-5 text-white" />
        </div>
        <div>
          <div className="flex items-center gap-2 mb-1">
            <span className="font-semibold text-gray-900">Aria</span>
            <span className="px-2 py-0.5 bg-green-100 text-green-700 text-xs rounded-full">
              Online
            </span>
          </div>
          <p className="text-gray-700 text-sm leading-relaxed">{message}</p>
        </div>
      </div>

      {showActions && (
        <div>
          <p className="text-sm font-semibold text-gray-900 mb-2">
            Quick actions:
          </p>
          <button className="w-full flex items-center gap-2 px-4 py-3 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-sm transition-colors group">
            <CheckCircle className="w-4 h-4 text-green-600" />
            <span className="text-gray-900 font-medium">Got it, continue</span>
          </button>
          <button className="w-full mt-2 text-sm text-gray-600 hover:text-gray-900 py-2 transition-colors">
            Tell me more about this feature
          </button>
        </div>
      )}
    </div>
  );
};